import { render, staticRenderFns } from "./TopPagesListStat.vue?vue&type=template&id=d924536c&scoped=true"
import script from "./TopPagesListStat.vue?vue&type=script&lang=js"
export * from "./TopPagesListStat.vue?vue&type=script&lang=js"
import style0 from "./TopPagesListStat.vue?vue&type=style&index=0&id=d924536c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d924536c",
  null
  
)

export default component.exports